module.exports = __webpack_public_path__ + "static/media/Ellipsis-1s-200px.707694f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Ellipsis-1s-200px.svg
// module id = 134
// module chunks = 0